import {
    ACTIVATE_UTR_AUTHENTICATE,
    ACTIVATE_UTR_AUTHENTICATE_SUCCESS,
    ACTIVATE_UTR_AUTHENTICATE_FAILED,
    ACTIVATE_UTR_CLEAR_DATA,
    CONNECT_PLAYER_THIRD_PARTY_ID,
    CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS,
    CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE,
} from './actionTypes/activate-utr-types';
import { showSplash, hideSplash } from './splash-actions';
import { validateActivateUtrToken, connectPlayerThirdPartyId } from '../api';
import { getThirdPartyConnection } from '../utils/activateUtr';
import { getOnboardingStatusV2, ONBOARDING_POST_NUO_DATA, ONBOARDING_POST_NUO_DATA_FAILURE } from './onboarding-actions';
import * as notificationAction from './notification-actions';

export const clearActivateUtrData = () => async (dispatch) => {
    dispatch({ type: ACTIVATE_UTR_CLEAR_DATA });
};

const showErrorPopUp = (type, displayMessage) => async (dispatch) => {
    const thirdPartyConnection = getThirdPartyConnection(type);
    const message = displayMessage || thirdPartyConnection?.errorDescription;

    dispatch(notificationAction.showErrorPopup({
        title: 'Activation Error',
        message,
        onConfirmClick: () => {
            window.location.href = thirdPartyConnection?.errorRedirectUrl;
        },
    }));
};

export const authenticateActivateUtrToken = (params) => async (dispatch, getState, { mainApi }) => {
    dispatch(showSplash({
        splash: 'load',
        title: 'Authenticating',
    }));

    dispatch({
        type: ACTIVATE_UTR_AUTHENTICATE,
        data: { activationType: params.type, activationToken: params.token },
    });

    const apiParams = {
        token: params.token,
        thirdPartyType: getThirdPartyConnection(params.type)?.type,
    };
    validateActivateUtrToken(mainApi, apiParams)
        .then((response) => {
            dispatch({ type: ACTIVATE_UTR_AUTHENTICATE_SUCCESS, data: { user: response.data } });
        })
        .catch((err) => {
            dispatch({ type: ACTIVATE_UTR_AUTHENTICATE_FAILED });
            dispatch(showErrorPopUp(params.type, err.response?.data?.DisplayMessage));
        })
        .finally(() => {
            dispatch(hideSplash());
        });
};

export const connectThirdPartyId = (params, isFromNuo = false) => async (dispatch, getState, { mainApi }) => {
    const { activationType, activationToken } = getState().activateUtr;

    if (params.type === activationType && params.token === activationToken) {
        if (isFromNuo) {
            dispatch({ type: ONBOARDING_POST_NUO_DATA });
        }
        dispatch(showSplash({
            splash: 'load',
        }));

        dispatch({ type: CONNECT_PLAYER_THIRD_PARTY_ID });

        try {
            const apiParams = {
                token: params.token,
                thirdPartyType: getThirdPartyConnection(params.type)?.type,
                isOnboardingV2: isFromNuo,
            };

            const response = await connectPlayerThirdPartyId(mainApi, apiParams);
            dispatch({ type: CONNECT_PLAYER_THIRD_PARTY_ID_SUCCESS, data: { redirectToken: response.data.token } });
            if (isFromNuo) {
                await dispatch(getOnboardingStatusV2());
            }
        } catch (err) {
            if (isFromNuo) {
                dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
            }
            dispatch({ type: CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE });
            dispatch(showErrorPopUp(params.type, err.response?.data?.DisplayMessage));
        } finally {
            dispatch(hideSplash());
        }
    } else {
        dispatch({ type: CONNECT_PLAYER_THIRD_PARTY_ID_FAILURE });
        dispatch(showErrorPopUp(params.type));
    }
};
